// System dependencies

import React from 'react';

// Props

export interface FormSpinnerPageProps {
  caption?: string | null;
  isActive: boolean;
}

const FormSpinnerPage: React.FC<FormSpinnerPageProps> = ({ caption = null, isActive }) => {
  return !isActive ? null : (
    <div className="absolute inset-0 z-10 flex flex-col items-center justify-center bg-white/90 backdrop-blur-0 dark:bg-slate-800/90">
      <div className="flex flex-col items-center">
        <div className="relative h-12 w-12">
          <div className="absolute h-full w-full rounded-full border-2 border-solid border-zinc-300 dark:border-zinc-700"></div>
          <div className="absolute h-full w-full animate-spin rounded-full border-2 border-solid border-zinc-700 border-t-transparent dark:border-zinc-300 dark:border-t-transparent"></div>
        </div>
        {caption && <div className="font-xl mt-2 text-center">{caption}</div>}
      </div>
    </div>
  );
};

export default FormSpinnerPage;
